import "./errorMessage.scss"
import ErrorIcon from "assets/icons/error.svg"
import React from "react"

export const ErrorMessage = ({ message }) => {
    return (
        <div className='error-message'>
            <img src={ErrorIcon} alt='error' />
            <p>{message}</p>
        </div>
    )
}
